module.exports = __webpack_public_path__ + "6ca0253cd9b16fcb5dcf9e7f7ca6c1ef.woff";


//////////////////
// WEBPACK FOOTER
// ./src/shared/fontello/font/fontello.woff
// module id = 1101
// module chunks = 0 1 2 3 4